<template>

    <form-with-base-message ref="form" :base-errors="getErrorForField('base')" class="container_form" :success-message="successMessage">

        <v-container fluid>
            <v-layout row wrap>
                <v-flex xs12>
                    <v-text-field
                            autocomplete="new-password"
                            v-model="email"
                            :placeholder="$vuetify.t('$vuetify.ResetPassword.emailPlaceholder')"
                            background-color="primary"
                            color="seconary"
                            solo
                            name="email"
                            :error-messages="getErrorForField('email')"
                            @focus="resetErrorForField('email')"
                    ></v-text-field>
                </v-flex>
                <v-flex xs12>
                    <v-text-field
                            autocomplete="new-password"
                            v-model="username"
                            :placeholder="$vuetify.t('$vuetify.ResetPassword.usernamePlaceholder')"
                            background-color="primary"
                            color="seconary"
                            solo
                            name="username"
                            :error-messages="getErrorForField('username')"
                            @focus="resetErrorForField('username')"
                    ></v-text-field>
                </v-flex>

                <v-flex xs12>
                    <v-btn block class="eco-button"
                           color="button-light"
                           type="submit"
                           large
                           @click.prevent="executeResetPassword()">
                        {{$vuetify.t('$vuetify.ResetPassword.resetPassword')
                        | uppercase }}
                    </v-btn>
                  <SharedLoginButtons></SharedLoginButtons>
                </v-flex>
            </v-layout>
        </v-container>

    </form-with-base-message>


</template>


<script>
    import FormWithBaseMessage from "../components/FormWithBaseMessage"
    import webappUri from "../mixins/webappUri"
    import formValidation from "../mixins/formValidation"
    import SharedLoginButtons from "../components/SharedLoginButtons";



    export default {
        data: function () {

            return {

                username: "",
                email: "",
                resetPasswordUri: this.getWebAppConfirmationUri("new-password"),
                errors: {},
                successMessage: {}
            }
        },
        mixins: [webappUri,formValidation],
        methods:{

            executeResetPassword(){
                const RESET_PASSWORD_MUTATION = require("../graphql/mutations/resetPassword.gql")
                this.$apollo.mutate({
                    client: "clientPublic",
                    // Query
                    mutation: RESET_PASSWORD_MUTATION,
                    // Parameters
                    variables: {
                        username: this.username,
                        email: this.email,
                        resetPasswordUri: this.resetPasswordUri


                    },

                }).then((result) => {

                    result = result.data.passwordLost


                    if(result._response.result){
                        this.errors = []
                        this.$refs.form.resetForm()
                        this.successMessage =
                            {
                                title: this.$vuetify.t("$vuetify.ResetPassword.successTitleReset"),
                                text: this.$vuetify.t("$vuetify.ResetPassword.successReset")
                            }

                    }else{
                        this.errors = this.collectErrors(result._response.errors, "ResetPassword")

                    }



                }).catch((error) => {

                    //TODO implementare default error catcher
                    // Error
                    console.error(error)

                })
            }

        },
        components: {
            FormWithBaseMessage,
            SharedLoginButtons
        }



    }
</script>


<style scoped lang="scss">

    .container_form {
        height: 350px;
        margin: auto 30px !important;

    }


</style>
